import cn from '@/lib/clsxm';

import Container from '@/components/@base/container';
import Props from '@/components/app/product/components/@shared/progress-bar/type';

export default function ProgressBar({ progressPercent, className, ...props }: Props) {
  return (
    <Container
      className={cn('h-[6px] w-full overflow-hidden rounded-full bg-[#FEA0001C]', className)}
      {...props}
    >
      <Container
        className='mr-auto h-full rounded-full bg-[linear-gradient(247.65deg,_#FFC107_-35.57%,_#FF9737_100%)]'
        style={{ width: `${progressPercent}%` }}
      ></Container>
    </Container>
  );
}
